module.exports = __webpack_public_path__ + "static/work-projects-2-9b80c6c1d2b41fbe48c6654a38842eb5.jpg";